<template>
  <div style="overflow-y: auto" 
    v-if="isPermittedAll([
        'HistoryGetAll'
    ]) && isMobile">
      <v-expansion-panels multiple v-model="expanded" class="custom-expansion">  
        <v-expansion-panel
          v-for="(history, i) in $store.state.transactionHistory"
        >
          <v-expansion-panel-header>
            <div  v-if="expanded.includes(i) === false">
              <div class="mb-2">
                <b >{{ history.TransactUser.UserGivenName }}</b>
              </div>

              <div>{{ history.TransactUtc | dateAtTime }}</div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content >
            <div>
              <div>
                <b>User</b>
                <p>{{ history.TransactUser.UserGivenName }}</p> 
              </div>
              <div>
                <b>Modified On</b>
                <p>{{ history.TransactUtc | dateAtTime }}</p> 
              </div>
              <div>
                <b>Before</b>
                <div class="overflow-x-auto">
                  <small>
                    <pre>{{displayBeforeDiff(history)}}</pre>
                  </small>
                </div>

              </div>
              <div >
                <b>After</b>
                <div class="overflow-x-auto">
                  <small>
                    <pre>{{displayAfterDiff(history)}}</pre>
                  </small>
                </div>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  
  <v-data-table
    v-else-if="isPermittedAll([
      'HistoryGetAll'
    ])"
    id="transaction-history-table"
    class="page-table"
    :headers="transactionHistoryFields"
    mobile-breakpoint="-1"
    :items="$store.state.transactionHistory"
    item-key="TransactionID"
    dense
    disable-pagination
    hide-default-footer
    fixed-header
    :options="{
      sortBy: ['TransactionName'],
      rowsPerPage: -1,
    }">
    <template
      v-slot:item="row">
      <tr>
        <td>{{row.item.TransactUser.UserGivenName}}</td>
        <td>{{row.item.TransactUtc | dateAtTime}}</td>
        <td>
          <small>
            <pre>{{displayBeforeDiff(row.item)}}</pre>
          </small>
        </td>
        <td>
          <small>
            <pre>{{displayAfterDiff(row.item)}}</pre>
          </small>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'TransactionHistoryTable',
  data() {
    return {
       expanded: [],
      transactionHistoryFields: [
        {
          text: 'User',
        },
        {
          text: 'Modified On',
        },
        {
          text: 'Before',
        },
        {
          text: 'After',
        },
      ],
    };
  },
  methods: {
    displayBeforeDiff(transaction) {
      let diff = 'NO RECORD';
      const beforeParsed = JSON.parse(transaction.BeforeBlob);

      if (transaction.BeforeBlob !== '{}') {
        diff = this.objectDiff(
          beforeParsed,
          JSON.parse(transaction.AfterBlob),
        );
      }

      const propertiesChanged = _.keys(diff);
      const isHidden = propertiesChanged.length === 1
        && _(propertiesChanged).first().includes('IsDeleted');

      if (isHidden) {
        diff = beforeParsed;
      }

      return diff;
    },
    displayAfterDiff(transaction) {
      let diff = this.objectDiff(
        JSON.parse(transaction.AfterBlob),
        JSON.parse(transaction.BeforeBlob),
      );

      const propertiesChanged = _.keys(diff);
      const isHidden = propertiesChanged.length === 1
        && _(propertiesChanged).first().includes('IsDeleted');

      if (isHidden) {
        diff = 'HIDDEN';
      }

      return diff;
    },
  },
   computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  created() {
    this.$store.dispatch('getTransactionHistory');
  },
};
</script>

<style lang="scss"></style>
